import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useStyles } from './OffersComponent.styles'
import { useTheme } from '@mui/material/styles'
import { Typography } from '@mui/material'
import { TotalAndPercentage } from '../TotalAndPercentage/TotalAndPercentage'
import { CustomLegends } from '../CustomLegends/CustomLegends'
import { LineChartComponent } from '../../../common/components/LineChartComponent/LineChartComponent'
import { useSelector } from '../../../store/hooks'
import { Overview } from '../../../modules/flyoutOverview/types'
import { OverviewEmptyState } from '../OverviewEmptyState/OverviewEmptyState'
import { numberFormat } from '@labrav/common'
import OverviewEmptyStateImage from '../../../common/images/overviewEmptyState.png'

export const OffersForChannelPartners = () => {
  const { classes } = useStyles()
  const theme = useTheme()
  const navigate = useNavigate()

  const { offersForChannelPartners } = useSelector<Overview>(
    state => state.flyoutOverview?.overview
  )

  const isOffersForChannelPartnerssDataEmpty =
    !offersForChannelPartners?.data ||
    Object.values(offersForChannelPartners.data).every(
      offer =>
        (offer.count === 0 || offer.count === null) &&
        (offer.percentage === 0 || offer.percentage === null)
    )

  const handleClick = () => {
    navigate('/flyout/offers-authorizations/resale-authorizations')
  }

  const awsCount = offersForChannelPartners?.data?.aws?.count
  const microsoftCount = offersForChannelPartners?.data?.microsoft?.count
  const gcpCount = offersForChannelPartners?.data?.gcp?.count

  const offersForChannelPartnersList = {
    aws: offersForChannelPartners?.data?.aws,
    microsoft: offersForChannelPartners?.data?.microsoft,
    gcp: offersForChannelPartners?.data?.gcp,
  }

  return (
    <>
      {isOffersForChannelPartnerssDataEmpty ? (
        <OverviewEmptyState
          imgUrl={OverviewEmptyStateImage}
          containerHeight={20.5}
          imageHeight={11.75}
          imageWidth={16.75}
          description="No offers for channel partners yet."
          button={
            <div
              className={classes.viewEmptyDetailsContainer}
              data-testid="buyers-view-details"
            >
              <Typography
                className={classes.viewDetailsText}
                onClick={handleClick}
              >
                View details
              </Typography>
            </div>
          }
        />
      ) : (
        <div
          data-testid={'offers-for-channel-partners-component'}
          className={classes.root}
        >
          <TotalAndPercentage
            total={offersForChannelPartners?.total}
            percentage={offersForChannelPartners?.percentage}
            type={offersForChannelPartners?.rise}
            label="in last 1 year"
          />
          <div
            className={classes.lineChartComponent}
            data-testid={'channel-partners-line-chart'}
          >
            <LineChartComponent
              classes={classes}
              data={offersForChannelPartnersList}
              colors={[
                theme.palette.awsGraph.main,
                theme.palette.microsoftGraph.main,
                theme.palette.gcpGraph.main,
              ]}
            />
            <div
              className={classes.legendsWrapper}
              data-testid={'channel-partners-custom-legend-wrapper'}
            >
              <CustomLegends
                legends={[
                  {
                    label: 'AWS:',
                    legendColor: theme.palette.awsGraph.main,
                    legendSize: 'small',
                    value: String(numberFormat(awsCount || 0)),
                  },
                  {
                    label: 'Microsoft:',
                    legendColor: theme.palette.microsoftGraph.main,
                    legendSize: 'small',
                    value: String(numberFormat(microsoftCount || 0)),
                  },
                  {
                    label: 'GCP:',
                    legendColor: theme.palette.gcpGraph.main,
                    legendSize: 'small',
                    value: String(numberFormat(gcpCount || 0)),
                  },
                ]}
              />
            </div>
          </div>
          <div
            className={classes.viewDetailsContainer}
            data-testid="channel-partners-view-details"
          >
            <Typography
              className={classes.viewDetailsText}
              onClick={handleClick}
            >
              View details
            </Typography>
          </div>
        </div>
      )}
    </>
  )
}
